import type { MessageDescriptor } from '@lingui/core';
import type { ReactNode } from 'react';
import { i18n } from '@lingui/core';

export const trans = (header: string | ReactNode | MessageDescriptor): string | ReactNode => {
  // lingui message id
  if (typeof header === 'string') {
    return i18n._(header);
  }
  // lingui message descriptors are objects with an 'id' property
  if (typeof header === 'object' && header !== null && 'id' in header) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- TypeScript 5 does not support type narrowing for object types with specific properties, so we need to assert the type here
    return i18n._(header as MessageDescriptor);
  }
  return header;
};
